import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import {
  Alert,
  Box,
  Grid,
  MenuItem,
  Paper,
  Snackbar,
  Typography,
} from "@mui/material";
import DataTable from "./components/DataTable";
import {
  deletePosition,
  getAllPositions,
} from "../../../../../actions/positions";

import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import CardStyle from "../../../shared/general/Card";
import AddIcon from "@mui/icons-material/Add";
import TextFieldTheme from "../../../shared/general/TextFieldTheme";
import DialogEditPosition from "./DialogEditPosition";
// import { getJobGroup } from "../../../../../actions/jobRecruit";
import PositionTable from "./PositionTable";
import AlertResponse from "../../../shared/general/AlertResponse";
import Notification from "../../../shared/general/Notification";
import DialogConfirmDelete from "../../../shared/general/DialogConfirmDelete";
import { getOrganizationStructure } from "../../../../../actions/organizationStructure";
import { getAllGroupLevelsByIdCompany } from "../../../../../actions/level";

//Translator TH-EN
import { useTranslation } from "react-i18next";
import { openNotificationAlert } from "../../../../../actions/notificationAlert";
import { JobManagementXlsx } from "./JobManagementXlsx";
import { getAllJobFamily } from "../../../../../actions/jobFamily";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "30px",
    "& .MuiTypography-h6": {
      fontSize: "1.5rem",
    },
  },
  headingPage: {
    marginBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(1),
    borderRadius: "20px",
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
  },
}));

const StyledHeadingPage = styled("div")({
  marginBottom: 16,
});

function Index(props) {
  const classes = useStyles();
  const { selectedCompany } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: jobFamilyStore } = useSelector((state) => state.jobFamily);
  const { result: positionList } = useSelector((state) => state.positions);
  const [isLoading, setIsLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [alertType, setAlertType] = useState(false);

  const [alertConfig, setAlertConfig] = useState({
    isOpen: false,
    type: "success",
    message: "",
  });

  const [drawerConfig, setDrawerConfig] = useState({
    isOpen: false,
    isEdit: false,
    data: null,
  });

  const [deleteConfig, setDeleteConfig] = useState({
    isOpen: false,
    data: {
      idPositions: null,
      positionsCode: "",
      positionsName: "",
    },
  });

  let setFirstPageChildFunc = null;
  const idCompany = selectedCompany ? selectedCompany.idCompany : userProfile.idCompany

  const [filterConfig, setFilterConfig] = useState({
    type: "position",
    name: "",
  });

  const handleAddPosition = () => {
    setDrawerConfig((prev) => ({
      ...prev,
      isOpen: true,
      isEdit: false,
      data: null,
    }));
  };

  const handleCloseDialog = () => {
    setDrawerConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const handleChangeFilter = (event) => {
    setFilterConfig((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
    // console.log(filterConfig)
    // if(setFirstPage){
    setFirstPageChildFunc();
    // }
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleCloseDeleteModal = () => {
    setDeleteConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const handleDeletePosition = async () => {
    const response = await dispatch(
      deletePosition(deleteConfig.data.idPositions)
    );

    if (response) {
      if (response.status === 200) {
        dispatch(
          openNotificationAlert({
            type: "success",
            message: `${t("DataSaveSuccessful")}`,
          })
        );
        dispatch(getAllPositions({ idCompany }));
        handleCloseDeleteModal();
      } else {
        dispatch(
          openNotificationAlert({
            type: "error",
            message: `${t("CantDeleteJobPosition")}`,
          })
        );
      }
    } else {
      dispatch(
        openNotificationAlert({
          type: "error",
          message: `${t("AnErrorOccurred")} ${t("PleaseContactAdmin")}`,
        })
      );
    }

    setDeleteConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const getFilteredData = () => {
    if (positionList) {
      if (filterConfig.name === "") return positionList;
      const filterData = positionList.filter((p) => {
        if (filterConfig.type === "position") {
          return p.positionsName && p.positionsName.includes(filterConfig.name);
        } else if (filterConfig.type === "section") {
          return p.sectionName && p.sectionName.includes(filterConfig.name);
        } else if (filterConfig.type === "department") {
          return (
            p.departmentName && p.departmentName.includes(filterConfig.name)
          );
        } else if (filterConfig.type === "division") {
          return p.divisionName && p.divisionName.includes(filterConfig.name);
        } else if (filterConfig.type === "business") {
          return p.businessName && p.businessName.includes(filterConfig.name);
        }
      });
      return filterData;
    } else {
      return [];
    }
  };

  useEffect(() => {
    // if (selectedCompany) {
      dispatch(getAllPositions({ idCompany }));
      dispatch(getAllJobFamily());
      dispatch(
        getOrganizationStructure({ idCompany })
      );
      dispatch(getAllGroupLevelsByIdCompany(idCompany));
    // }
  }, []);

  const handleXlsxExport = () => {
    if (positionList) {
      JobManagementXlsx(positionList);
    } else {
      return;
    }
  }

  return (
    <div className={classes.root}>
      <StyledHeadingPage>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6">{t("ManageJobPosition")}</Typography>
          </Grid>
          <Grid item>
            <ButtonBlue
              variant={"contained"}
              startIcon={<DownloadRoundedIcon />}
              onClick={() => handleXlsxExport()}
              style={{ marginRight: '12px' }}
            >
              {t("Download")}
            </ButtonBlue>
            <ButtonBlue
              variant={"contained"}
              startIcon={<AddIcon />}
              // onClick={() => {
              //   setOpenDialog({
              //     ...openDialog,
              //     isOpen: true,
              //   });
              // }}
              onClick={handleAddPosition}
            >
              {t("AddJobPosition")}
            </ButtonBlue>
          </Grid>
        </Grid>
      </StyledHeadingPage>
      <Box display="flex" gap="8px" marginBottom="16px">
        <TextFieldTheme
          name="type"
          value={filterConfig.type}
          onChange={handleChangeFilter}
          style={{ width: "160px" }}
          select
        >
          <MenuItem value="position">{t("JobPosition")}</MenuItem>
          <MenuItem value="section">{t("Section")}</MenuItem>
          <MenuItem value="department">{t("Department")}</MenuItem>
          <MenuItem value="division">{t("Division")}</MenuItem>
          <MenuItem value="business">{t("Business")}</MenuItem>
        </TextFieldTheme>
        <TextFieldTheme
          name="name"
          value={filterConfig.name}
          onChange={handleChangeFilter}
          inputProps={{
            placeholder: `${t("Search")}`,
          }}
        />
      </Box>

      <CardStyle style={{ padding: 16 }}>
        <PositionTable
          data={getFilteredData()}
          setFirstPage={(setFirstPage) => {
            setFirstPageChildFunc = setFirstPage;
          }}
          setDrawerConfig={setDrawerConfig}
          setDeleteConfig={setDeleteConfig}
        />
      </CardStyle>

      <DialogEditPosition
        drawerConfig={drawerConfig}
        onClose={handleCloseDialog}
        setOpenAlert={setOpenAlert}
        setAlertType={setAlertType}
        setAlertConfig={setAlertConfig}
        selectedCompany={selectedCompany}
      />

      <DialogConfirmDelete
        open={deleteConfig.isOpen}
        handleClose={handleCloseDeleteModal}
        label={t("JobPosition")}
        text={`(${deleteConfig.data.positionsCode}) ${deleteConfig.data.positionsName}`}
        handleDelete={handleDeletePosition}
      />

      <Notification notify={alertConfig} setNotify={setAlertConfig} />
    </div>
  );
}

export default Index;
